// every word the page shows belonging to spore's vocab
// see also VOCAB.md for quick ref points in usr-friendly format
// these may change during or out of beta

export const words = {
  mark: 'spore.bond',
  feed: 'feed',
  substrate: 'substrate',
  post: 'matter',
  composer: 'release some matter...',
  germinate: 'germinate',
  germinatePlaceholder: 'germinate...',
  germinations: (count) => `${count} ${count === 1 ? 'germination' : 'germinations'}`,
  viewGerminations: 'view germinations',
  germination: 'germination',
  emptyFeed: [
    'no matter here yet. be the first.',
    'make something that matters.',
    'what matters to you today?',
  ],
  emptySpore: 'nothing released yet.',
  back: '← burrow',
  sporePrint: 'render spore print',
  rot: 'rot',
  rotConfirm: 'rot this matter? it goes for good, and its germinations go with it.',
  decay: 'decay',
  decompose: 'decompose',
  decayed: 'decayed',
  decomposing: 'decomposing',
  restore: 'restore',
  emptyDecayed: 'nothing decayed. decay matter to keep it out of view, for you alone.',
  emptyDecomposing: 'nothing decomposing.',
  morel: 'morel',
  morels: 'morels',
  writeMorel: 'write a morel',
  readMorel: 'read morel',
  morelTitle: 'title',
  morelBody: 'the morel',
  morelPlaceholder: 'take your time...',
  releaseMorel: 'release morel',
  shareToFeed: 'share to the feed as a card',
  shareNow: 'share to the feed',
  unshare: 'take the card back',
  onTheFeed: 'on the feed',
  morelHint: 'a morel is long form. it lives on your spore and on its own page. a card for it goes to the feed only if you share it.',
  puffball: 'puffball',
  puffballPlaceholder: "what's growing?",
  puffballSet: 'set puffball',
  puffballClear: 'take it down',
  puffballHint: 'one line of status on your spore. a new one replaces the old.',
  rotAll: 'rot everything here',
  rotAllConfirm: 'rot all decomposing? it goes for good, and its germinations go with it.',
  bond: 'bond',
  unbond: 'unbond',
  bonded: 'bonded',
  hosts: 'hosts',
  mutuals: 'mutuals',
  fuse: 'fuse',
  fused: 'fused',
  prune: 'prune',
  pruned: 'pruned',
  soil: 'soil',
  stewards: 'stewards',
  propagate: 'propagate',
  tiers: {
    public: 'public',
    followers: 'hosts and fused',
    friends: 'fused only',
    private: 'private',
  },
};